"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var theme_1 = __importDefault(require("../../../styles/theme"));
var makeStyles_1 = __importDefault(require("../../../util/makeStyles"));
exports.default = (0, makeStyles_1.default)((0, styles_1.createStyles)({
    root: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        backgroundColor: 'white',
        boxShadow: theme_1.default.shadows.weak,
        borderRadius: 4,
        userSelect: 'none',
        // Keep this border so that the content does not jump when attaching "rootOpened" class
        border: '1px solid transparent',
        minHeight: 58,
    },
    rootOpened: {
        border: theme_1.default.borders.highlight,
    },
    openerRoot: {
        padding: 16,
        display: 'flex',
        flex: '1 1 auto',
        alignItems: 'center',
        '&:not(:first-child)': {
            paddingLeft: 0,
        },
    },
    openerRootClickable: {
        cursor: 'pointer',
    },
    icon: {
        marginRight: 4,
    },
    title: {
        marginRight: 4,
        flex: '0 0 auto',
    },
    valueText: {
        whiteSpace: 'pre-wrap',
    },
    chevron: {
        marginLeft: 'auto',
        transition: theme_1.default.transitions.easeOutFast,
    },
    chevronOpened: {
        transform: 'rotate(-180deg)',
    },
    popoverRoot: {
        padding: '16px 0px',
        borderRadius: 4,
        boxShadow: theme_1.default.shadows.medium,
    },
    popoverRootNonForm: {
        minWidth: 380,
        maxWidth: 520,
    },
    popoverRootForm: {
        width: '100%',
        paddingTop: 8,
    },
    selectableOptionTitle: __assign(__assign({}, theme_1.default.fonts.headline2), { color: theme_1.default.textColors.primaryLight, cursor: 'default' }),
    actionButton: {
        marginRight: 16,
    },
    subText: {
        marginLeft: '1ch',
    },
    selectOptionVariant: {
        paddingRight: '36px !important',
    },
    childrenContainer: {
        display: 'grid',
        columnGap: 16,
        gridAutoFlow: 'column',
        paddingRight: 16,
        alignItems: 'center',
    },
}));
